import { Redirect } from "@redotech/react-router-util/redirect";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import {
  ConversionPermissions,
  MarketingPermissions,
  OrderManagementPermissions,
} from "@redotech/redo-model/permissions";
import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import { Navigate } from "react-router-dom";

const reportBreadcrumb = breadcrumbSlot();

export const analyticsRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Analytics", breadcrumbNavigate: false },
    children: [
      { index: true, element: <Navigate replace to="reports" /> },
      {
        path: "returns-claims/*",
        element: (
          <Redirect
            match={/home\/analytics\/returns-claims/}
            replaceValue="order-management/analytics/returns-claims"
          />
        ),
      },
      {
        path: "reports",
        handle: {
          breadcrumb: reportBreadcrumb,
          permission: OrderManagementPermissions.VIEW_REPORTS,
        },
        async lazy() {
          const { ReportPage } = await import("./reports/report");
          return { element: <ReportPage breadcrumb={reportBreadcrumb} /> };
        },
      },
      {
        path: "order-tracking",
        handle: {
          breadcrumb: "Order Tracking",
          permission: MarketingPermissions.VIEW_ORDER_TRACKING_ANALYTICS,
        },
        async lazy() {
          const { OrderTrackingAnalytics: Analytics } = await import(
            "./order-tracking/order-tracking-analytics"
          );
          return { Component: Analytics };
        },
      },
      {
        path: "marketing",
        handle: {
          breadcrumb: "Marketing",
          permission: MarketingPermissions.VIEW_MARKETING_ANALYTICS,
        },
        async lazy() {
          const { MarketingAnalytics: Analytics } = await import(
            "./marketing/marketing-analytics"
          );
          return { Component: Analytics };
        },
      },
      {
        path: "try-first",
        handle: {
          breadcrumb: "Try First",
          permission: ConversionPermissions.ACCESS_CONVERSION,
        },
        async lazy() {
          const { TryFirstAnalytics } = await import(
            "./try-first/try-first-analytics"
          );
          return { Component: TryFirstAnalytics };
        },
      },
    ],
  },
];
